"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Checkbox = _interopRequireDefault(require("../Checkbox/Checkbox"));
var _FormElementError = _interopRequireDefault(require("../Form/FormElementError"));
var _Label = _interopRequireDefault(require("../Label/Label"));
var _TextButton = _interopRequireDefault(require("../v1/components/TextButton/TextButton"));
var _TextInput = _interopRequireDefault(require("../TextInput/TextInput"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class PasswordControl extends _react.Component {
  static defaultProps = {
    showCheckboxId: 'PasswordControl-show-password',
    showForgotPassword: true,
    required: true,
    requiredError: 'Please enter your password.'
  };
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
      isValid: true
    };
    const {
      requiredError,
      minLength
    } = props;
    this._pattern = minLength ? `.{${minLength},}` : null;
    if (minLength) {
      this._error = /*#__PURE__*/_react.default.createElement(_FormElementError.default, null, "Please enter at least ", minLength, " characters.");
    } else {
      this._error = /*#__PURE__*/_react.default.createElement(_FormElementError.default, null, requiredError);
    }
    this._generateKey();
  }
  _onPasswordFocus = () => {
    const {
      onFocus
    } = this.props;
    if (onFocus) {
      onFocus();
    }
  };
  _onPasswordChange = evt => {
    this.setState({
      value: evt.target.value,
      isValid: true
    });
  };
  _onInvalid = validationState => {
    const {
      onInvalid
    } = this.props;
    this.setState({
      isValid: validationState.valid
    });
    if (onInvalid) {
      onInvalid(validationState);
    }
  };
  _onToggleShowPasswordChange = () => {
    this._generateKey();
    this.setState((prevState, props) => {
      return {
        showPassword: !prevState.showPassword
      };
    });
  };
  _generateKey() {
    this._key = `password-${Date.now()}`;
  }

  /**
   * Provides the form data as an object for submission.
   *
   * @public
   * @returns {Object} - The form data to submit.
   */
  submit() {
    const value = this._input.node.value;
    return value ? {
      password: value
    } : null;
  }
  render() {
    const {
      className,
      showCheckboxId,
      showForgotPassword,
      label,
      placeholder,
      showPlaceholder,
      helpNode,
      required,
      onForgotPasswordClick
    } = this.props;
    const {
      value,
      showPassword,
      isValid
    } = this.state;
    const classes = (0, _classnames.default)('PasswordControl', 'FormElement', {
      'FormElement-contains-error': !isValid
    }, className);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes
    }, label, /*#__PURE__*/_react.default.createElement("div", {
      className: "PasswordControl-input"
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      key: this._key,
      ref: node => {
        this._input = node;
      },
      name: "password",
      type: showPassword ? 'text' : 'password',
      required: required,
      pattern: this._pattern,
      defaultValue: value,
      placeholder: showPlaceholder && placeholder ? placeholder : '',
      onChange: this._onPasswordChange,
      onInvalid: this._onInvalid,
      onFocus: this._onPasswordFocus
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "PasswordControl-show"
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      id: showCheckboxId,
      label: /*#__PURE__*/_react.default.createElement(_Label.default, null, "Show"),
      onChange: this._onToggleShowPasswordChange
    }), /*#__PURE__*/_react.default.createElement(_TextButton.default, {
      onClick: this._onToggleShowPasswordChange
    }, showPassword ? 'Hide' : 'Show'))), helpNode && /*#__PURE__*/_react.default.createElement("div", {
      className: "FormElement-help-text"
    }, helpNode), !isValid && this._error, showForgotPassword && /*#__PURE__*/_react.default.createElement(_TextButton.default, {
      className: "PasswordControl-forgot",
      onClick: onForgotPasswordClick
    }, "Forgot Password?"));
  }
}
exports.default = PasswordControl;